import '../styles/Manuscript.css';
import Layout from '../layouts/Layout.js'
import { Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Paragraph from '../components/paragraphs/Paragraph';
import { fetchManuscript, downloadFile } from '../utils/fetchManuscript.js';

// Hidden page (not in the navigation): displays the PDF without changing the URL and starts the download
const Manuscript = ({component: Component, ...rest}) => {
  return (
    <Route {...rest} render={props => (
        <ManuscriptContent></ManuscriptContent>
    )} />
  );
}

const ManuscriptContent = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    fetchManuscript()
      .then(blob => {
        objectUrl = URL.createObjectURL(blob);
        setPdfUrl(objectUrl);
        downloadFile(blob, 'ROUX_Sterenn_Doctoral_Manuscript.pdf');
      })
      .catch(() => setError(true));
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, []);

  if (!pdfUrl) {
    return (
      <Layout child={
        <div className="ManuscriptMessage">
          <Paragraph text={error ? "The manuscript is not available right now." : "Loading the manuscript…"} />
        </div>
      }>
      </Layout>
    );
  }

  return <iframe className="Manuscript" src={pdfUrl} title="Manuscript" />;
}

export default Manuscript;
